// Web build: worker is emitted as a separate file and loaded by URL.
// This form lets the browser cache the worker script independently of the
// main bundle. Swapped for worker-loader.offline.ts in the offline build.
export function createWorker(): Worker {
  return new Worker(new URL('./worker.ts', import.meta.url), { type: 'module' });
}
